export const colors = {
  primary:         '#7367F0',
  primaryLight:    '#9E95F5',
  primaryLighter:  '#EDE7FF',
  primaryDark:     '#5E50EE',
  primaryShadow:   'rgba(115, 103, 240, 0.35)',

  success:         '#28C76F',
  successLight:    '#E6F9EE',
  successDark:     '#1DB85E',

  warning:         '#FF9F43',
  warningLight:    '#FFF3E5',
  warningDark:     '#E08030',

  danger:          '#EA5455',
  dangerLight:     '#FDEAEA',
  dangerDark:      '#D03C3C',

  info:            '#00CFE8',
  infoLight:       '#E0F9FC',
  infoDark:        '#009BB0',

  bg:              '#F8F7FA',
  bgAlt:           '#F1EFF6',
  surface:         '#FFFFFF',
  surfaceRaised:   '#FFFFFF',
  border:          '#DBDADE',
  borderLight:     '#EBEBEB',
  divider:         '#F0EFF5',

  text: {
    heading:  '#4C4E6F',
    body:     '#5D596C',
    muted:    '#9092A9',
    disabled: '#C9C7CE',
    inverse:  '#FFFFFF',
  },

  sidebar: {
    bg:         '#FFFFFF',
    border:     '#DBDADE',
    text:       '#5D596C',
    textActive: '#7367F0',
  }
} as const;
